import { presentDiscardClosureConfirmation } from 'owa-calendar-compose-form-actions';

export const closeItem = (): void => {
    presentDiscardClosureConfirmation();
};
